<template>
  <div class="send-fee-tip">
    <el-dialog title="发送费用确认" :visible.sync="visible" :before-close="closeDialog" width="720px" :close-on-click-modal="false">
      <div>
        <div style="margin-bottom:24px">校验通过！本次发送费用如下，请确认费用明细：</div>
        <div>
          <WTable :WTableOpts="WTableOpts">
            <!--            <template #containers="{ row }">-->
            <!--              <div style="text-align: center">-->
            <!--                <div v-for="(item, index) in row.containers" :key="item.billNo">-->
            <!--                  <p style="height: 40px; line-height: 40px" :style="{-->
            <!--                        borderTop: index > 0 ? '1px solid #EBEEF5' : '',-->
            <!--                      }">-->
            <!--                    {{ item.containerNo }}-->
            <!--                  </p>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </template>-->
          </WTable>
        </div>
        <div class="balance-box">

          <div class="balance-coupon" v-if="activeFeeData.couponAmount > 0">
            <span>使用优惠券</span>
            <el-input-number v-model="couponNumber" :step="1" step-strictly size="mini" style="margin:0 8px" @change="handleChange" :min="0" :max="activeFeeData.currentlyAvailableCouponAmount" label="描述文字"></el-input-number>
            <span>张</span>
          </div>

          <div class="balance-text" v-if="activeFeeData.couponAmount > 0">
            <span>总消费金额：</span>
            <span>{{ activeFeeData.totalAmount }}</span>
            <span>U币</span>
          </div>
          <div class="balance-text" v-if="activeFeeData.couponAmount > 0">
            <span>优惠券抵扣：</span>
            <span>-{{ activeFeeData.discountAmount }}</span>
            <span>U币</span>
          </div>
          <div class="balance-text">
            <span>实际支付：</span>
            <span class="balance-num">{{ activeFeeData.payAmount }}</span>
            <span>U币</span>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" :loading="sendType" class="submit-btn" @click="send">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {bulkSend, feeConfirmation} from "@/api/vgmBusiness";

export default {
  name: "SendFeeTip",
  props: {
    visible: Boolean,
    feeData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      sendType: false,
      activeFeeData: this.feeData,
      num: 0,
      couponNumber: 0,
      WTableOpts: {
        data: [],
        tableAttrs: { border: true, maxHeight: '384px' },
        tableColAttrs: [
          { prop: 'billNo', label: '提单号',  },
          { prop: 'containerNo', label: '箱号',  },
          { prop: 'price', label: '消费金额', width: '100px'  }
        ]
      }
    }
  },
  created () {
    this.WTableOpts.data = this.feeData.feeItems
  },
  methods: {
    // 发送
    send(){
      this.sendType = true
      bulkSend({fee: this.feeData.fee,ids: this.feeData.ids,useCouponAmount: this.couponNumber}).then(res=>{
        this.$emit('sendSuccess')
      }).finally(() => {
        this.sendType = false
      })
    },
    // 关闭
    closeDialog () {
      this.$emit("closeDialog")
    },
    handleChange () {
      feeConfirmation( {useCouponAmount:this.couponNumber,ids:this.feeData.ids}).then(res=>{
        this.activeFeeData = { ...res, ids: this.feeData.ids }
      })
    },
  }
}
</script>

<style scoped lang="less">
.send-fee-tip {
  color: #333333;
  font-size: 14px;

  ::v-deep .pt-110px {
    padding-top: 50px !important;
  }
  ::v-deep .pb-70px {
    padding-bottom: 30px !important;
  }
  .dialog-footer {
    text-align: right;
    margin-top: 24px;
  }
  .el-button {
    height: 32px;
  }
  .submit-btn {
    width: 80px;
    padding: 0;
  }
  .balance-coupon {
    margin-bottom: 24px;
    ::v-deep .el-input__inner {
      padding: 0;
    }
    ::v-deep .el-input-number {
      width: 90px !important;
      .el-input__inner {
        height: 28px;
      }

      .el-input__inner {
        border-radius: 0;
      }

      .el-input-number__increase {
        font-size: 16px;
        color: #5c5c66;
      }
    }
  }

  // ::v-deep .el-table {
  //   .is-center {
  //     padding: 0 !important;
  //   }
  //   .el-table__row {
  //     .cell {
  //       padding: 0 !important;
  //     }
  //   }

  //   .cell-div {
  //     padding-left: 16px;
  //     border-top: 1px solid #ebeef5;
  //   }
  //   .cell-div:nth-child(1) {
  //     border: none;
  //   }
  // }

  .balance-box {
    font-weight: 500;
    text-align: right;
    margin-top: 24px;
    .balance-text {
      line-height: 24px;
    }

    .balance-num {
      color: #f58d0b;
      font-size: 16px;
      margin-right: 4px;
      margin-left: 16px;
    }
  }
}
</style>